<script>
import { fandomBasicMixin } from "src/modules/fandom_mixins_module.js";
export default {
  mixins: [fandomBasicMixin]
};
</script>

<template>
  <div contact-us-content class="w-100 bg-vodafone text-white py-5" v-easyadmin="easyadminId" v-if="isContentVisibleToUser()" :class="[contentType]">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-md-6" v-html="content.description">
        </div>
        <div class="col-12 col-md-3 d-flex align-items-center justify-content-center mt-4 mt-md-0">
          <a :href="content.button.url" :target="getTarget(content.button)" class="btn btn-outline-white" v-if="content.button">
            {{content.button.title}}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
[contact-us-content] {
  p {
    @include font-size(1.75rem);
    margin-bottom: 0;

    @include media-breakpoint-down(sm) {
      text-align: center;
    }
  }
}
</style>